import React from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { mainGreen, mainRed } from '../utils/color'

const headCellSx = { p: 0, color: '#fff', borderRight: '1px solid #000' }
const bodyCellSx = { padding: '5px 0', borderRight: '1px solid #000' }
const totalCellSx = { ...bodyCellSx, color: '#fff' }

const STATISTIC_ROWS = [
	{ key: 'cashOrders', label: 'Tiền mặt' },
	{ key: 'transferOrders', label: 'Chuyển khoản' },
	{ key: 'appOrders', label: 'App' },
]

// Bảng doanh thu theo hình thức thanh toán, dùng chung cho trang thống kê và báo cáo thu chi
export default function OrderStatisticsTable({ statistics, sx }) {
	const totals = statistics?.statistics
	return (
		<Table sx={{ mb: 3, background: '#fff', ...sx }}>
			<TableHead sx={{ background: mainGreen, border: 'none' }}>
				<TableRow>
					<TableCell sx={headCellSx}>Thanh toán</TableCell>
					<TableCell sx={headCellSx}>Số đơn</TableCell>
					<TableCell sx={headCellSx}>Doanh thu (đ)</TableCell>
					<TableCell sx={headCellSx}>Sản lượng (kg)</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{STATISTIC_ROWS.map((row) => {
					const group = statistics?.[row.key]
					return (
						<TableRow key={row.key}>
							<TableCell sx={bodyCellSx}>{row.label}</TableCell>
							<TableCell sx={bodyCellSx}>{group?.totalOrdered}</TableCell>
							<TableCell sx={bodyCellSx}>{group?.totalRevenue?.toLocaleString()}</TableCell>
							<TableCell sx={bodyCellSx}>{group?.totalQuantity}</TableCell>
						</TableRow>
					)
				})}
				<TableRow sx={{ background: mainRed }}>
					<TableCell sx={totalCellSx}>TỔNG</TableCell>
					<TableCell sx={totalCellSx}>{totals?.totalOrdered}</TableCell>
					<TableCell sx={totalCellSx}>{totals?.totalRevenue?.toLocaleString()}</TableCell>
					<TableCell sx={totalCellSx}>{totals?.totalQuantity}</TableCell>
				</TableRow>
			</TableBody>
		</Table>
	)
}
